module.exports = __webpack_public_path__ + "static/img/A107.eb1e2bb7.jpg";